import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesByDeviceTypeQuery } from "../graphql/queries";
import type {
  AnalyticsSalesByDeviceTypeQueryType,
  AnalyticsSalesByDeviceTypeQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesByDeviceTypeQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesByDeviceTypeQueryType,
    AnalyticsSalesByDeviceTypeQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesByDeviceTypeQueryType,
    AnalyticsSalesByDeviceTypeQueryVariablesType
  >(AnalyticsSalesByDeviceTypeQuery, options);
};
